<template>
  <el-dialog :visible.sync="show" :fullscreen="true" :show-close="false" v-loading="loading" custom-class="mcd">
    <div slot="title">
      SQL建模
      <el-button size="mini" icon="el-icon-upload" class="mcd-save" @click="toSave" type="primary">保 存</el-button>
      <el-button size="mini" icon="el-icon-circle-close" class="mcd-close" @click="show = false">退 出</el-button>
    </div>
    <el-row>
      <el-col :span="6">
        <div class="mcd-meta-table" v-loading="loading1">
          <el-select v-model="rdbDataSourceId" placeholder="请选择数据源" title="数据源" @change="onDataSourceChange">
            <el-option v-for="db in rdbDataSources" :key="db.rdbDataSourceId" :label="db.name" :value="db.rdbDataSourceId">
              <template v-if="db.desc">
                {{ db.name }}<span class="mcd-option-desc">{{db.type}} - {{ db.desc }} ({{db.projectName}} - {{db.systemName}})</span>
              </template>
              <template v-else>
                {{ db.name }}<span class="mcd-option-desc">{{db.type}} ({{db.projectName}} - {{db.systemName}})</span>
              </template>
            </el-option>
          </el-select>
          <p v-for="metaTable in metaTables" :key="metaTable.name" @click="selectMetaTable(metaTable)" :class="getMetaTableClass(metaTable)" title="表">
            <span>{{metaTable.name}}</span>
            <span>{{metaTable.cmt}}</span>
          </p>
        </div>
      </el-col>
      <el-col :span="18">
        <el-input class="mcd-design-sql" type="textarea" :rows="10" placeholder="请输入SQL" v-model="sql"></el-input>
        <div class="mcd-design-column">
          <el-table :data="metaColumns" :stripe="true" size="mini" empty-text="请先选择表后查看该表的字段">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="cmt" label="注释" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="dataType" label="数据类型"></el-table-column>
            <el-table-column prop="dataLength" label="长度"></el-table-column>
            <el-table-column prop="dataScale" label="精度">
              <template slot-scope="scope">
                <span v-if="scope.row.dataScale">{{scope.row.dataScale}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="nullable" label="可否为空">
              <template slot-scope="scope">
                <span v-if="scope.row.nullable">可以</span>
                <span v-else>不可</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="保存模型" :visible.sync="showForm" append-to-body>
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-position="top">
        <el-form-item label="模型名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入模型名称" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="访问控制类型" prop="acType">
          <el-radio-group v-model="form.acType" size="mini">
            <el-radio-button :label="acType.key" v-for="acType in acTypes" :key="acType.key">{{acType.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="数据类型" prop="type">
          <el-radio-group v-model="form.type" size="mini">
            <el-radio-button label="OBJECT">单条数据</el-radio-button>
            <el-radio-button label="LIST">列表</el-radio-button>
            <el-radio-button label="PAGE">分页</el-radio-button>
            <el-radio-button label="FIELD">单个字段</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请填写模型描述" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="showForm = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="doSave(false)">保 存</el-button>
        <el-button size="mini" type="primary" @click="doSave(true)">保存并退出</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { acTypes } from '@/config'

export default {
  name: 'sql-config-dialog',
  data () {
    return {
      acTypes: acTypes,
      show: false,
      loading: false,
      rdbDataSources: [],
      rdbDataSourceId: null,
      model: {},
      loading1: false,
      metaTables: [],
      metaColumns: [],
      selectedMetaTable: {},
      sql: '',
      showForm: false,
      form: {
        name: '',
        acType: '',
        type: '',
        desc: ''
      },
      formRule: {
        name: [{ required: true, message: '请输入模型名称', trigger: 'blur' }],
        acType: [{ required: true, message: '请选择访问控制类型', trigger: 'change' }],
        type: [{ required: true, message: '请选择数据类型', trigger: 'change' }]
      }
    }
  },
  watch: {
    model (model) {
      this.rdbDataSourceId = model.dataSourceId || null
      this.sql = model.sql || ''
      this.form = { name: model.name, acType: model.acType, type: model.type, desc: model.desc }
      this.loadDataSourceMetadata()
    }
  },
  methods: {
    open (model) {
      if (!model) {
        this.model = {}
        this.show = true
      } else {
        this.show = true
        this.loadModel(model)
      }

      this.$http.request({
        method: 'get',
        url: '/api/cgRdbDataSources'
      }).then((res) => {
        this.rdbDataSources = res.data.data || []
      })
    },
    loadModel (model) {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgModels/${model.modelId}`
      }).then((res) => {
        this.model = res.data.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    onDataSourceChange () {
      this.sql = ''
      this.loadDataSourceMetadata()
    },
    loadDataSourceMetadata () {
      this.metaTables = []
      this.metaColumns = []
      this.selectedMetaTable = {}

      if (!this.rdbDataSourceId) {
        return
      }

      this.loading1 = true
      this.$http.request({
        method: 'get',
        url: `/api/cgRdbDataSources/${this.rdbDataSourceId}/metadata`
      }).then((res) => {
        this.metaTables = res.data.data || []
        this.loading1 = false
      }).catch(() => {
        this.loading1 = false
      })
    },
    selectMetaTable (metaTable) {
      if (this.selectedMetaTable === metaTable) {
        this.selectedMetaTable = {}
      } else {
        this.selectedMetaTable = metaTable
      }

      this.metaColumns = this.selectedMetaTable.metaColumns || []
    },
    getMetaTableClass (metaTable) {
      return this.selectedMetaTable === metaTable ? 'active' : ''
    },
    toSave () {
      if (!this.rdbDataSourceId) {
        alert('请选择数据源')
        return
      }
      if (!this.sql) {
        alert('请输入SQL')
        return
      }
      this.showForm = true
    },
    doSave (exit) {
      if (!this.rdbDataSourceId) {
        alert('请选择数据源')
        return
      }
      if (!this.sql) {
        alert('请输入SQL')
        return
      }

      this.$refs.form.validate((success) => {
        if (!success) {
          return false
        }

        let modelId = this.model.modelId
        this.$http.request({
          method: !modelId ? 'post' : 'put',
          url: !modelId ? '/api/cgModels' : `/api/cgModels/${modelId}`,
          data: JSON.stringify({
            dataSourceId: this.rdbDataSourceId,
            name: this.form.name,
            acType: this.form.acType,
            type: this.form.type,
            desc: this.form.desc,
            sql: this.sql,
            buildType: 'SQL'
          })
        }).then((res) => {
          this.model = res.data.data
          this.showForm = false
          if (exit) {
            this.show = false
          }
          this.$emit('save', this.model)
        })
      })
    }
  }
}
</script>

<style>
.mcd-design-sql{margin:10px;}
</style>
